import request from '@/utils/request'

// 获取采购订单申请主表信息
export function coopPrCreateHead(businessId) {
  return request({
    url: `/api/coop/coopPurchaseApplyHead/selectHead/${businessId}`,
    method: 'get'
  })
}

// 获取采购订单申请明细
export function selectDetail(businessId) {
  return request({
    url: `/api/coop/coopPurchaseApplyItem/selectItem/${businessId}`,
    method: 'get'
  })
}

// 查询系统最低价
export function selectLowestPrice(obj) {
  return request({
    url: '/api/coop/coopPurchaseApplyItem/selectLowestPrice',
    method: 'post',
    data: obj
  })
}
